import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import { Language } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Language';

export interface ApiArrearsResponse {
  id: string;
  status: ApiArrearsStatus;
  dueDate: string;
  amount: number;
  reportingPeriod: {
    date: string;
    status: ApiReportingPeriodStatus;
  };
  lender: {
    code: string;
    name: ApiLocalizedString;
    institutionNumber: string;
    transitNumber: string;
    transitMunicipality: string;
  };
  loan: {
    number: number;
    referenceNumber: string;
    amount?: number;
    premiumAmount?: number;
    approvalDate?: string;
  };
  property: {
    address: {
      civicNumber: string;
      street: string;
      municipality: string;
      province: string;
      postalCode: string;
    };
  };
}

export const ApiArrearsStatuses = {
  Active: 'active',
  Inactive: 'inactive'
} as const;

export type ApiArrearsStatus = (typeof ApiArrearsStatuses)[keyof typeof ApiArrearsStatuses];

export const ApiReportingPeriodStatuses = {
  Open: 'open',
  Closed: 'closed'
} as const;

export type ApiReportingPeriodStatus =
  (typeof ApiReportingPeriodStatuses)[keyof typeof ApiReportingPeriodStatuses];

type ApiLocalizedString = {
  fr: string;
  en: string;
};

export const toArrears = (apiArrears: ApiArrearsResponse, language: Language): Arrears => {
  return {
    id: apiArrears.id,
    status: apiArrears.status == ApiArrearsStatuses.Active ? 'active' : 'inactive',
    dueDate: apiArrears.dueDate,
    amount: apiArrears.amount,

    reportingPeriodStatus:
      apiArrears.reportingPeriod.status == ApiReportingPeriodStatuses.Open ? 'open' : 'closed',
    reportingPeriodDate: apiArrears.reportingPeriod.date,

    lenderCode: apiArrears.lender.code,
    lenderName: apiArrears.lender.name[language],
    lenderInstitutionNumber: apiArrears.lender.institutionNumber,
    lenderTransitNumber: apiArrears.lender.transitNumber,
    lenderTransitMunicipality: apiArrears.lender.transitMunicipality,

    loanNumber: apiArrears.loan.number,
    loanReferenceNumber: apiArrears.loan.referenceNumber,
    loanAmount: apiArrears.loan.amount,
    loanPremiumAmount: apiArrears.loan.premiumAmount,
    loanApprovalDate: apiArrears.loan.approvalDate,
    loanInformationMissing:
      apiArrears.loan.amount === undefined ||
      apiArrears.loan.premiumAmount === undefined ||
      apiArrears.loan.approvalDate === undefined,

    propertyAddressCivicNumber: apiArrears.property.address.civicNumber,
    propertyAddressStreet: apiArrears.property.address.street,
    propertyAddressMunicipality: apiArrears.property.address.municipality,
    propertyAddressProvince: apiArrears.property.address.province,
    propertyAddressPostalCode: apiArrears.property.address.postalCode
  };
};
